import { connect } from 'react-redux';
import { setItemError } from 'src/reducers/common/itemReducer';
import {
  getConfirmJobs,
  getDownloadPayCsvJobs,
  getImportPayCsvJobs,
  REDUCER_NAME
} from 'src/reducers/employees/employeePays';
import EmployeePayForm from '../components/EmployeePayForm';

const mapStateToProps = state => ({
  confirmPayJobs: getConfirmJobs(state) || {},
  downloadPayCsvJobs: getDownloadPayCsvJobs(state) || {},
  importPayCsvJobs: getImportPayCsvJobs(state) || {}
});
const mapDispatchToProps = dispatch => ({
  clearRollbackError: () => dispatch(setItemError(REDUCER_NAME, { rollbackEmployeePay: null }))
});
export default connect(mapStateToProps, mapDispatchToProps)(EmployeePayForm);
